import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthScreen } from "@/components/auth/auth-screen";
import { hrEmployeeApi } from "@/lib/api/hr";
import { setHrEmployeeSession } from "@/lib/auth/storage";
import { ApiError } from "@/lib/api/client";

export default function EmployeeLoginPage() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await hrEmployeeApi.login(identifier.trim(), password);
      setHrEmployeeSession({
        token: res.token,
        role: "hr_employee",
        employee: res.employee,
      });
      navigate("/employee");
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : "Could not sign in. Try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthScreen
      title="Employee sign in"
      description="Use your employee ID or email and password — not the attendance device PIN."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="identifier">Employee ID or email</Label>
          <Input
            id="identifier"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            className="h-12 text-base"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="h-12 text-base"
          />
        </div>
        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error}
          </p>
        )}
        <Button type="submit" className="h-12 w-full text-base" size="lg" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthScreen>
  );
}
